import { render, staticRenderFns } from "./CustomerSecurity.vue?vue&type=template&id=71e31902&"
import script from "./CustomerSecurity.vue?vue&type=script&lang=ts&"
export * from "./CustomerSecurity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports